import { format, isValid } from 'date-fns';

export const dateColumnWithSecondsFormatter = (date) => {
	if ((date && date === '0001-01-01T00:00:00') || !date) {
		return '';
	}
	return isValid(new Date(date)) ? format(new Date(date), 'yyyy-MM-dd HH:mm:ss') : '';
};
